/**
 * @module lib/utils
 */

/**
 * Function to create CSS class names
 *
 * @param {String} name The base name
 * @param {String} selector string to append to the base name
 * @returns String
 */
export var createClassName = function createClassName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return selector ? name + ' ' + name + '-' + selector : name;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2-ui/lib/component-helpers/utils.js
// module id = 189
// module chunks = 0